import { Styled } from './article-card-footer.styles';

export type ArticleCardFooterType = {
  description: string;
  title: string;
};

export const ArticleCardFooter: React.FC<ArticleCardFooterType> = ({
  description,
  title,
}) => (
  <Styled.Footer>
    <Styled.FooterHeadline size="small" forwardedAs="p">
      {title}
    </Styled.FooterHeadline>
    <Styled.BodyCopy size="small" noMargin lineHeight="dense">
      {description}
    </Styled.BodyCopy>
  </Styled.Footer>
);
